import { configureStore } from "@reduxjs/toolkit";

import onboardClientSlice from "../slice/clientOnboardDataSlice";
import modalNavSlice from "../slice/modalNavigationSlice";
import authSliceReducer from "../slice/authSlice";
import onboardResellerReducer from "../slice/resellerDataSlice";
import listingSlice from "../slice/listingDataSlice";
import commissionSlice from "../slice/commissionSlice";
import globalFiltersSlice from "../slice/globalFiltersSlice";
import dashboardCountSlice from "../slice/countsSlice";
import dropDownListSlice from "../slice/dropDownListSlice";
import loaderSlice from "../slice/loaderSlice";
import AclSlice from "../slice/aclSlice";
import addService from "../slice/addService";
import LogoSlice from "../slice/logoSlice";

const store = configureStore({
  reducer: {
    onboardClientSlice: onboardClientSlice,
    modalNavSlice: modalNavSlice,
    authSliceReducer: authSliceReducer,
    onboardResellerReducer: onboardResellerReducer,
    listingSlice: listingSlice,
    commissionSlice: commissionSlice,
    globalFiltersSlice: globalFiltersSlice,
    dashboardCountSlice: dashboardCountSlice,
    dropDownListSlice: dropDownListSlice,
    loaderSlice: loaderSlice,
    aclSlice: AclSlice,
    addService: addService,
    logoSlice: LogoSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export default store;
